var React = require('react');

function Dining (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 2c-.751 0-1.38.372-1.855.822S5.3 3.824 4.992 4.416C4.376 5.599 4 6.901 4 8c0 1.85 1.284 3.406 3 3.855V22h2V11.855c1.716-.45 3-2.005 3-3.855 0-1.099-.376-2.401-.992-3.584-.308-.592-.676-1.144-1.152-1.594S8.751 2 8 2zm7 0v14 1 5h2v-5.145c1.716-.45 3-2.005 3-3.855 0-1.03-.256-3.461-.773-5.834-.259-1.186-.577-2.329-1.008-3.258-.215-.464-.454-.88-.789-1.234S16.598 2 16 2h-1zM8 4c.078 0 .239.047.48.275s.519.613.754 1.064C9.704 6.242 10 7.442 10 8c0 1.117-.883 2-2 2s-2-.883-2-2c0-.558.296-1.758.766-2.66.235-.451.512-.836.754-1.064S7.922 4 8 4zm9 2.695l.273.896C17.756 9.805 18 12.373 18 13c0 .723-.436 1.239-1 1.59V6.695z"}));
}

Dining.defaultProps = {"viewBox":"0 0 24 24","xmlnsV":"https://vecta.io/nano"};

module.exports = Dining;

Dining.default = Dining;
